"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.array.splice");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.set");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var arraysHaveSameValues = function arraysHaveSameValues(a, b) {
  var aSet = new Set(a);
  var bSet = new Set(b);

  if (aSet.size !== bSet.size) {
    return false;
  }

  var _iterator = _createForOfIteratorHelper(aSet),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;

      if (!bSet.has(item)) {
        return false;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return true;
};

var Accordion = /*#__PURE__*/function (_React$Component) {
  _inherits(Accordion, _React$Component);

  var _super = _createSuper(Accordion);

  function Accordion(props) {
    var _this;

    _classCallCheck(this, Accordion);

    _this = _super.call(this, props);
    _this.state = {
      activeItems: props.activeItems
    };
    _this.handleItemClick = _this.handleItemClick.bind(_assertThisInitialized(_this));
    _this.handleExpandAll = _this.handleExpandAll.bind(_assertThisInitialized(_this));
    _this.handleCollapseAll = _this.handleCollapseAll.bind(_assertThisInitialized(_this));
    return _this;
  } // eslint-disable-next-line camelcase


  _createClass(Accordion, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (!arraysHaveSameValues(nextProps.activeItems, this.props.activeItems)) {
        var newActiveItems;

        if (nextProps.grouped) {
          newActiveItems = nextProps.activeItems.length ? [nextProps.activeItems[0]] : [];
        } else {
          newActiveItems = nextProps.activeItems.slice();
        }

        this.setState({
          activeItems: newActiveItems
        });
      }
    }
  }, {
    key: "updateItems",
    value: function updateItems(newItems) {
      if (this.props.onActiveItemsChange) {
        this.props.onActiveItemsChange(newItems);
      } else {
        this.setState({
          activeItems: newItems
        });
      }
    }
  }, {
    key: "handleItemClick",
    value: function handleItemClick(itemId) {
      var grouped = this.props.grouped;
      var newActiveItems;

      if (grouped) {
        newActiveItems = this.state.activeItems[0] === itemId ? [] : [itemId];
      } else {
        newActiveItems = _toConsumableArray(this.state.activeItems);
        var activeIndex = newActiveItems.indexOf(itemId);

        if (activeIndex > -1) {
          newActiveItems.splice(activeIndex, 1);
        } else {
          newActiveItems.push(itemId);
        }
      }

      this.updateItems(newActiveItems);
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          accordionId = _this$props.id; //Here we need to map over the children to filter out any child with a value of null

      this.childrenFiltered = [];

      _react.default.Children.forEach(children, function (child) {
        if (child) {
          _this2.childrenFiltered.push(child);
        }
      });

      return _react.default.Children.map(this.childrenFiltered, function (item, index) {
        if (!item) {
          return null;
        }

        var itemId = item.props.id || index;
        var isOpen = _this2.state.activeItems.indexOf(itemId) !== -1;
        return /*#__PURE__*/_react.default.cloneElement(item, {
          id: "".concat(accordionId, "__").concat(itemId),
          isOpen: isOpen,
          tag: 'li',
          onTriggerClick: function onTriggerClick() {
            _this2.handleItemClick(itemId);
          }
        });
      });
    }
  }, {
    key: "handleExpandAll",
    value: function handleExpandAll() {
      var allItemIds = _react.default.Children.map(this.childrenFiltered, function (item) {
        return item.props.id;
      });

      this.updateItems(allItemIds);
    }
  }, {
    key: "handleCollapseAll",
    value: function handleCollapseAll() {
      this.updateItems([]);
    }
  }, {
    key: "renderExpandCollapseAll",
    value: function renderExpandCollapseAll() {
      var activeItems = this.state.activeItems;

      if (!activeItems.length) {
        return /*#__PURE__*/_react.default.createElement("button", {
          type: "button",
          className: "expand-link",
          onClick: this.handleExpandAll
        }, "Expand all");
      }

      return /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "collapse-link",
        onClick: this.handleCollapseAll
      }, "Collapse all");
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          showGlobalControl = _this$props2.showGlobalControl,
          title = _this$props2.title,
          onActiveItemsChange = _this$props2.onActiveItemsChange,
          activeItems = _this$props2.activeItems,
          grouped = _this$props2.grouped,
          children = _this$props2.children,
          id = _this$props2.id,
          attrs = _objectWithoutProperties(_this$props2, ["className", "showGlobalControl", "title", "onActiveItemsChange", "activeItems", "grouped", "children", "id"]);

      var classes = (0, _classnames.default)(className, 'accordion');
      var expandCollapseClasses = (0, _classnames.default)({
        'expand-collapse-all': true,
        'has-title': !!title
      });
      return /*#__PURE__*/_react.default.createElement("div", _extends({
        className: classes
      }, attrs), showGlobalControl && /*#__PURE__*/_react.default.createElement("div", {
        className: expandCollapseClasses
      }, title, this.renderExpandCollapseAll()), /*#__PURE__*/_react.default.createElement("ul", {
        className: "accordion-list"
      }, this.renderItems()));
    }
  }]);

  return Accordion;
}(_react.default.Component);

Accordion.defaultProps = {
  grouped: false,
  showGlobalControl: false,
  className: undefined,
  onActiveItemsChange: undefined,
  children: null,
  activeItems: [],
  title: null
};
Accordion.propTypes = {
  id: _propTypes.default.string.isRequired,
  className: _propTypes.default.string,
  grouped: _propTypes.default.bool,
  children: _propTypes.default.node,
  onActiveItemsChange: _propTypes.default.func,

  /**
   * Array of item ids
   */
  activeItems: _propTypes.default.array,
  showGlobalControl: _propTypes.default.bool,
  title: _propTypes.default.node
};
var _default = Accordion;
exports.default = _default;
//# sourceMappingURL=Accordion.js.map